import type { AllKeyOf } from 'chaika-common-types';
import { COMMON_LAB_ENTRY_TYPE_ID, COMMON_LAB_ENTRY_TYPE_WITH_INTERNAL_ID, Currency } from 'chaika-enums';
import React from 'react';

export interface AnyObject {
    [key: string]: any; // для отлючения suppressImplicitAnyIndexErrors
}

export const enum SortingOrder {
    ASC = 'asc',
    DESC = 'desc',
}
export type FunctionType<P, R> = (params: P) => R;
export type ReactChildComponent<P = null> = (props: P) => React.ReactNode;
export const SYSTEM_USER_ID = 'a25459f7-1112-4300-aea4-f9e1fa98ce58';
export const DOCTOR_APPOINTMENT_SERVICE_ID = '00beaaf4-c1fd-4a27-b72e-6cc4ef7745aa';
export const labEntryTypeIdsSet = new Set([
    'af5036ba-c9ec-453c-86a4-82c54291db2f',
    '11c865db-b699-4564-ba75-01cbf20c0d96',
    COMMON_LAB_ENTRY_TYPE_ID,
    COMMON_LAB_ENTRY_TYPE_WITH_INTERNAL_ID,
]);
export const ONLINE_OFFICE_TYPE_ID = '6ccd22c6-ff2e-4b5c-8731-8e356c12fa5c';
export const RECEPTION_OFFICE_TYPE_ID = '9d930131-2f2b-4e79-864d-0f5a58383545';
export const PROCEDURE_OFFICE_TYPE_ID = 'b3de2e7d-7f81-4f4f-8da8-01533559b3dc';
export const COURSE_SERVICE_TAG_ID = 'da2122be-1bf2-4e7c-8b1a-5b089cc5c94b';
export const COVID_SERVICE_ID = '63161c18-122d-40ff-8257-c5e483407969';

export const DOCTOR_DISCOUNT_PLAN_ID = '8ba63739-4cf7-4f01-811f-7991fe8d9f1e';
export const HEAD_DOCTOR_DISCOUNT_PLAN_ID = '28804502-2099-418c-943f-3f742c3b046e';
export const OFFICE_DISCOUNT_PLAN_ID = '6bd1d9f0-ef76-4eba-95a9-bf1f04c7c325';
export const WAIT_FOR_GL_PLAN_ID = 'f9686215-651b-4387-b922-64cbd1c24c22';
export const AHEALTH_DISCOUNT_PLAN_ID = 'c9282b04-2d51-461b-9346-cbeb11766ce7';
export const PRACTICE_DISCOUNT_PLAN_ID = '480a7fbb-d36c-4df4-88f8-facbfcae4b6b';
export const AHEALTH_DISCOUNT_VALUE = 8;

export const DISABLED_PALN_IDS: string[] = [WAIT_FOR_GL_PLAN_ID];
export function isIncludeDisabledPlan(plans: { id: string }[]): boolean {
    return plans.some(plan => DISABLED_PALN_IDS.includes(plan.id));
}

export function isPlanWithDiscount(planId: string): boolean {
    return [
        DOCTOR_DISCOUNT_PLAN_ID,
        HEAD_DOCTOR_DISCOUNT_PLAN_ID,
        OFFICE_DISCOUNT_PLAN_ID,
        AHEALTH_DISCOUNT_PLAN_ID,
        PRACTICE_DISCOUNT_PLAN_ID,
    ].includes(planId);
}

export const ENTRY_MEDICAL_CASE_BLOCK_ID = 'f5f8fd5e-dd12-4c77-a5dd-e4ba085bccb8';
export const ENTRY_RENDERED_SERVICE_BLOCK_ID = '2a82eb26-d668-4368-a494-3bd207179a15';
export const ENTRY_GRADE_BLOCK_ID = 'c98df8ad-ff33-413d-b8fe-d3347fc78b9c';
export const ENTRY_TREATMENT_PLAN_BLOCK_ID = 'bba9e96f-fa4d-4242-bdcc-e0e985313e9b';
export const ENTRY_EPISODES_BLOCK_ID = '92192767-1257-4d05-8efc-fa84b7fee061';

export const PaymentUrlTypeYooKassa = 'payment-url-yookassa';
export const PaymentUrlTypeSBP = 'payment-url-sbp';

export const TABLE_CELL_NAME_SEPARATOR = '[cellName]:';

export const ALL_SERVICE_GROUP_ID = 'a76aa03b-c09b-4d85-a211-1f765c2c1e01';

export const INNER_LABORATORY_ID = '63926e60-ee5b-46a4-ba65-69274949a0ed';

export const SERVICE_WITH_CONCLUSION_ID = 'd7e97b65-fbb0-4552-9995-7114b05da27c';

export const ENTRY_TYPE_FOR_PENALTY_ID = '0cc1dbd7-968a-4f6c-a4c8-10f083025442';

export const RECURRING_SUBSCRIPTION_MONTHLY_SERVICE_ID = 'df94912b-cd4c-4a54-926f-bdf21c7f76df';
export const RECURRING_SUBSCRIPTION_ANNUAL_SERVICE_ID = '359ed65d-a420-4211-bf3b-9c1849a10bd3';

export const CurrencyIcon: AllKeyOf<Currency> = {
    [Currency.RUB]: '₽',
    [Currency.AED]: 'Dh',
    [Currency.USD]: '$',
    [Currency.EUR]: '€',
    [Currency.GEL]: '₾',
    [Currency.AMD]: '֏',
    [Currency.GBP]: '£',
};

export enum ForeignClinics {
    ChaikaTbilisi = '982f5d4e-4b85-47c9-b083-5eb4e4ced41d',
}

export enum ClinicTypeName {
    Kandinsky = 'Kandinsky',
    Tbilisi = 'Tbilisi',
    Chaika = 'Chaika',
    ChaikaArmenia = 'ChaikaArmenia',
}

export const ForeignLegalEntity = {
    [ClinicTypeName.Kandinsky]: '986fe69d-9763-48d9-9d36-22dd47e0daf9',
    [ClinicTypeName.Tbilisi]: '764370ae-cafa-416c-9f05-ddc452f3a154',
    [ClinicTypeName.ChaikaArmenia]: '99563e0e-4533-43d7-a1aa-3ae6dfb1ecb9',
} as const;

export const entryTypeIdsWithHideAuthor = new Set<string>([
    // Протокол врачебной комиссии
    'c555f909-d6e9-4037-8131-b4094ee4e0b4',
]);

export const WEBSITE_USER_ID = '9e3e9a2d-3cb9-4aa9-9cf7-7211123ac559';

export const ENTRY_FILE_DEFAULT_NAME = 'entry.pdf';
